import { AuthAction } from "~/components/auth/useAuth";
import { TrackEvent, track } from "~/utils/analytics";
import { ensureRedirectIsSafe } from "@sequoiacap/client-shared/utils/ensureRedirectIsSafe";
import { getFirstParam } from "@sequoiacap/shared/utils/getFirstParam";
import { isFromAmpersandWebVC } from "~/network/ampersand-web-vc-bridge";
import { loginWithinWebView } from "~/network/auth-api";
import { useEffect, useState } from "react";
import Header from "~/components/header/Header";
import LoginContainer from "~/components/auth/LoginContainer";
import Router, { useRouter } from "next/router";
import styles from "~/components/auth/LoginContainer.module.scss";
import type { Page } from "~/utils/page";

const LoginPage: Page = () => {
  const router = useRouter();
  const ios = isFromAmpersandWebVC();
  const [loadingForAmpersandWebVC, setLoadingForAmpersandWebVC] = useState(ios);

  const next = ensureRedirectIsSafe(getFirstParam(router.query.redirect));
  useEffect(() => {
    const iosUid = window?._uid;

    if (ios && iosUid) {
      track(TrackEvent.loginWithinWebView, {
        user_id: iosUid,
      });
      loginWithinWebView(iosUid)
        .then(() => Router.replace(next ?? "/"))
        .catch((err) => {
          console.error(err);
          setLoadingForAmpersandWebVC(false);
        });
    }
  }, [ios, next]);

  if (loadingForAmpersandWebVC) {
    return null;
  }

  return (
    <div className={styles.loginPage}>
      {!isFromAmpersandWebVC() && <Header className={styles.header} hideMenu />}
      <LoginContainer />
    </div>
  );
};

LoginPage.authProps = {
  whenAuthenticated: AuthAction.REDIRECT_TO,
  whenUnauthenticated: AuthAction.RENDER,
  redirectUrl: (router) => {
    const { redirect: maybeNext } = router.query;
    const next = ensureRedirectIsSafe(getFirstParam(maybeNext));
    return next ?? "/";
  },
};

export default LoginPage;
